import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, categoryText: string): any[] {
    if(!items) return [];

    if(!searchText && !categoryText) return items;

    if(searchText) {
      searchText = searchText.toLowerCase();
    }
    if(categoryText) {
      categoryText = categoryText.toLowerCase();
    }

    if (!searchText) {
      return items.filter( it => {
        return it.category.toLowerCase() === categoryText ||
               categoryText === "all" || categoryText === "tümü"
      });
    }
    else if (!categoryText){
      return items.filter( it => {
        return (it.category.toLowerCase() === categoryText || categoryText === "all" || categoryText === "tümü")
      });
    }
    else {
      console.log("else....");
      return items.filter( it => {
        return it.job.name.toLowerCase().includes(searchText) &&
          (it.category.toLowerCase() === categoryText || categoryText === "all" || categoryText === "tümü")
      });
    }
  }
}
